import {ReadOnlyContext} from '@/components/Form/ReadOnly.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import SidePane from '../SidePane.jsx'
import {PropertiesContext} from './Properties.mjs'
import Text from './PropertiesControllerText.jsx'

const MapPane = () => {
    const map = useMapContext()

    return (
        <PropertiesContext.Provider value={[map.data]}>
            <ReadOnlyContext.Provider value={true}>
                <SidePane>
                    <Text
                        label="项目名称"
                        prop="prjName"
                    />

                    <Text
                        label="分支号"
                        prop="sVer"
                    />

                    <Text
                        label="地图版本号"
                        prop="mapRev"
                    />

                    <Text
                        label="地图更新时间"
                        prop="uptTime"
                    />
                </SidePane>
            </ReadOnlyContext.Provider>
        </PropertiesContext.Provider>
    )
}

export default MapPane
